import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { alpha } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Link from '@material-ui/core/Link';
import MenuItem from '@material-ui/core/MenuItem';
import {NavLink, } from 'react-router-dom';
import MenuList from '@material-ui/core/MenuList';
import SearchIcon from '@material-ui/icons/Search';
import { withRouter } from "react-router-dom";
import {
    AccountTreeTwoTone,
    AssessmentTwoTone,
    ContactsTwoTone,
    DeveloperBoardTwoTone,
    DonutSmallTwoTone,
    ExpandMore,
    HomeTwoTone,
    LockOpenTwoTone, AccountCircle,
    SupervisorAccountTwoTone, PowerTwoTone, SystemUpdateAltTwoTone
} from '@material-ui/icons';
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TermsAndConditions from "./TermsAndConditions";
import ExpandLess from '@material-ui/icons/ExpandLess';
import Collapse from "@material-ui/core/Collapse";
import InputBase from "@material-ui/core/InputBase";
import {GreenButton} from "./common/ButtonsConstants";
import Modal from "@material-ui/core/Modal";
import * as CommonUtils from "../util/CommonUtils";
import {BOUND_USER_ID} from "../Constants";
import {exportReport} from "../util/ApiUtils";
import { t, getLanguage } from "../i18n";

const drawerWidth = 320;
const top = 50;
const left = 50;

const classes = (theme => ({
    root: {
        display: 'flex',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(1),
    },
    toolbar: theme.mixins.toolbar,
    search: {
        //position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: alpha(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: alpha(theme.palette.common.white, 0.25),
        },
        //marginRight: theme.spacing(2),
        position: "absolute",
        right: "21%",
        marginLeft: 0,
        width: '100%',
        top: '20%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(3),
            width: 'auto',
        },
    },
    searchIcon: {
        padding: theme.spacing(0, 2),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    clearIcon: {
        height: '100%',
        position: 'absolute',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: '20ch',
        },
    },
    signOut: {
        top: '20%',
    },
}));

class Copyright extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
        };
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }
    showModal() {
        this.setState({
            show: true
        });
    }

    closeModal() {
        this.setState({
            show: false,
        });
    }
    render() {
        return (
            <div>
                <Typography variant="body2" color="textSecondary" align="center" className="App-copyright">
                    <Link href="/">{t('footer.home')}</Link> | <Link onClick={this.showModal} style={{ cursor: "pointer" }}>{t('footer.terms')}</Link><br/>
                    {'Copyright © '}
                    <Link color="inherit" href="#">
                        { t('app.name') }
                    </Link>{' '}
                    {new Date().getFullYear()}
                    {'.'}
                </Typography>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.show}
                    onClose={() => this.closeModal()}
                >
                    <div style={{
                        position: 'absolute',
                        width: 1200,
                        backgroundColor: "white",
                        border: '2px solid #000',
                        //boxShadow: theme.shadows[5],
                        //padding: theme.spacing(2, 4, 3),
                        top: `${top}%`,
                        left: `${left}%`,
                        transform: `translate(-${top}%, -${left}%)`,
                    }}>
                        <TermsAndConditions user={this.props.currentUser}/>
                    </div>
                </Modal>
            </div>
        );
    }
}

function buildMenuItems() {
    return [
    {
        name: t('menu.context.title'), icon: <AccountTreeTwoTone htmlColor='green'/>, href: '/context-of-organisation',
        children : [
            { name: t('menu.context.purpose'), href:  "/context-of-organisation/purpose" },
            { name: t('menu.context.orgChart'), href:  "/context-of-organisation/orgChart" },
            { name: t('menu.context.scope'), href:  "/context-of-organisation/scope" },
            { name: t('menu.context.objectives'), href:  "/context-of-organisation/objectives" },
            { name: t('menu.context.policies'), href:  "/context-of-organisation/policies" },
            { name: t('menu.context.positionDescriptions'), href:  "/context-of-organisation/position-descriptions" },
            { name: t('menu.context.termsAndDefinitions'), href:  "/context-of-organisation/terms-and-definitions" },
            { name: t('menu.context.acronyms'), href:  "/context-of-organisation/acronyms-and-abbreviations" },
            { name: t('menu.context.references'), href:  "/context-of-organisation/references" },
            { name: t('menu.context.interestedParties'), href:  "/context-of-organisation/interested-parties" },
            { name: t('menu.context.externalInternalIssues'), href:  "/context-of-organisation/external-internal-issues" },
        ],
    },
    {
        name: t('menu.leadership.title'), icon: <SupervisorAccountTwoTone htmlColor='green'/>, href: "/leadership"
    },
    {
        name: t('menu.planning.title'), icon: <DonutSmallTwoTone htmlColor='green'/>, href: "/planning",
        children : [
            { name: t('menu.planning.risk.label'), href:  "/planning/risk" },
            { name: t('menu.planning.legalRequirements'), href:  "/planning/legal-requirements" },
        ],
    },
    {
        name: t('menu.projectManagement.title'), icon: <DonutSmallTwoTone htmlColor='green'/>, href: "/project-management",
        children : [
            { name: t('menu.projectManagement.projectManagement'), href:  "/project-management/project-management" },
        ],
    },
    {
        name: t('menu.support.title'), icon: <ContactsTwoTone htmlColor='green'/>, href: "/support",
        children : [
            { name: t('menu.support.p1'), href:  "/support/ims" },
            { name: t('menu.support.p2'), href:  "/support/mm-resources" },

            { name: t('menu.support.p3'), href:  "/support/measurement-and-traceability" },
            { name: t('menu.support.p4'), href:  "/support/org-knowledge" },
            { name: t('menu.support.p5'), href:  "/support/competence" },
            { name: t('menu.support.p6'), href:  "/support/awareness" },
            { name: t('menu.support.p7'), href:  "/support/communication" },

            { name: t('menu.support.p8'), href:  "/support/documented-information" },
            { name: t('menu.support.p9'), href:  "/support/training" },

            { name: t('menu.support.p10'), href:  "/support/property-belonging" },

            { name: t('menu.support.p11'), href:  "/support/preservation" },
            { name: t('menu.support.p12'), href:  "/support/post-delivery" },

            { name: t('menu.support.p13'), href:  "/support/internal-audit" },
            { name: t('menu.support.p14'), href:  "/support/nonconformity" },
            { name: t('menu.support.p15'), href:  "/support/continual-improvement" },
            { name: t('menu.support.p16'), href:  "/support/risk-assessment" },
            { name: t('menu.support.p17'), href:  "/support/on-site-induction" },
            { name: t('menu.support.p18'), href:  "/support/incident-notification" },

            { name: t('menu.support.p19'), href:  "/support/description-of-the-incident" },

            { name: t('menu.support.p20'), href:  "/support/incident-investigation" },
            { name: t('menu.support.p21'), href:  "/support/operation" },
            { name: t('menu.support.p22'), href:  "/support/ppe" },
        ],
    },
    {
        name: t('menu.operation.title'), icon: <DeveloperBoardTwoTone htmlColor='green'/>, href: "/operation",
        children : [
            { name: t('menu.operation.imsImprovementRegister'), href:  "/operation/ims-improvement-register" },
            { name: t('menu.operation.imsAuditChecklist'), href:  "/operation/ims-audit-checklist" },
            { name: t('menu.operation.managementReviewMeeting'), href:  "/operation/management-review-meeting" },
            { name: t('menu.operation.approvedSupplierList.title'), href:  "/operation/approved-supplier" },
            { name: t('menu.operation.approvedContractors.title'), href:  "/operation/approved-contractor" },
            { name: t('menu.operation.calibrationCertificates'), href:  "/operation/calibration-schedule" },
            // { name: "Electrical Equipment Register", href:  "/operation/equipment-register" },
            { name: t('menu.operation.auditPlan.title'), href:  "/operation/audit-plan" },
            { name: t('menu.operation.chemicalRegister'), href:  "/operation/msds" },
            { name: t('menu.operation.ncr.title'), href:  "/operation/noncomformance" },
            { name: t('menu.operation.swms'), href:  "/operation/swms" },
            { name: t('menu.operation.communicationPlan'), href:  "/operation/communication-plan" },
            { name: t('menu.operation.incidentNotification'), href:  "/operation/incident-notification-template" },
            { name: t('menu.operation.trainingRegister.title'), href:  "/operation/training-register" },
            { name: t('menu.operation.documentRetention.title'), href:  "/operation/document-retention" },
            { name: t('menu.operation.emergencyResponseTesting'), href:  "/operation/emergency-response-testing" },
        ],
    },
    {
        name: t('menu.flowchart.pageTitle'), icon: <SupervisorAccountTwoTone htmlColor='green'/>, href: "/flowcharts"
    },
    {
        name: t('menu.performance.title'), icon: <AssessmentTwoTone htmlColor='green'/>, href: "/performance",
        children : [
            { name: t('menu.performance.performanceReview'), href:  "/performance/performance-review-template" },
        ],
    }];
}

class MainDecorator extends Component {
    constructor(props) {
        super(props);
        let searchTerm = sessionStorage.getItem('searchTerm');
        console.log('searchTerm', searchTerm);
        this.state = {
            searchTerm: searchTerm,
            filterMenuBy: '',
            lang: getLanguage(),
        };
        this.signOut = this.signOut.bind(this);
        this.search = this.search.bind(this);
        this.filterMenu = this.filterMenu.bind(this);
        this.routeChange = this.routeChange.bind(this);
        this.onLangChange = this.onLangChange.bind(this);
    }

    componentDidMount() {
        if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
            window.addEventListener('i18n-language-changed', this.onLangChange);
        }
    }

    componentWillUnmount() {
        if (typeof window !== 'undefined' && typeof window.removeEventListener === 'function') {
            window.removeEventListener('i18n-language-changed', this.onLangChange);
        }
    }

    onLangChange() {
        this.setState({ lang: getLanguage() });
    }

    routeChange() {
        this.props.history.push(`/search-results/${encodeURIComponent(this.state.searchTerm)}`);
        // window.location.reload();
    }

    populateMenuItems(isAuthenticated, filterMenuBy) {
        // Coerce isAuthenticated to a strict boolean to properly handle boolean or string values ('true'/'false')
        const auth = (typeof isAuthenticated === 'string') ? (isAuthenticated === 'true') : !!isAuthenticated;
        // Safety: ensure currentUser access won't throw when null/undefined
        const currentUser = this.props.currentUser || {};

        // Example placeholder for admin-only adjustments (kept for future use)
        if (auth && ['admin@statuo.com.au', 'tanya.happy@live.com'].includes(currentUser.username)) {
            // no-op for now
        }

        // If not authenticated -> show short menu (Home, Sign In)
        if (!auth) {
            return [
                { name: t('menu.home'), icon: <HomeTwoTone htmlColor='green' />, href: "/" },
                { name: t('menu.signIn'), icon: <LockOpenTwoTone htmlColor='orange' />, href: "/sign-in" },
            ];
        }

        // If authenticated and has accepted T&C -> show full menu filtered by search term
        if (currentUser.hasAcceptedTermsAndConditions) {
            const menu = buildMenuItems();
            return menu.filter(item => {
                if (!filterMenuBy) {
                    return true;
                }
                if (item.name.toLowerCase().includes(filterMenuBy.toLowerCase()) || item.href.toLowerCase().includes(filterMenuBy.toLowerCase())) {
                    return true;
                }
                if (item.children) {
                    for (let i = 0; i < item.children.length; i++) {
                        let child = item.children[i];
                        if (child.name.toLowerCase().includes(filterMenuBy.toLowerCase()) || child.href.toLowerCase().includes(filterMenuBy.toLowerCase())) {
                            return true;
                        }
                    }
                }
                return false;
            });
        }

        // Fallback: return empty array (no menu items to show)
        return [];
    }

    filterMenu(value) {
        this.setState({
            filterMenuBy: value
        });
    }

    search({ target }) {
        let searchTerm = target.value;
        console.log('search', searchTerm);
        this.setState({
            searchTerm: searchTerm
        }, () => sessionStorage.setItem('searchTerm', searchTerm));
    }

    signOut() {
        this.filterMenu("");
        this.props.onLogout();
    }

    showTermsAndConditions() {
        const auth = (typeof this.props.isAuthenticated === 'string') ? (this.props.isAuthenticated === 'true') : !!this.props.isAuthenticated;
        const currentUser = this.props.currentUser || {};
        console.log('auth', auth);
        console.log('this.props.currentUser', currentUser);
        console.log('this.props.currentUser.hasAcceptedTermsAndConditions', currentUser.hasAcceptedTermsAndConditions);
        return auth && !currentUser.hasAcceptedTermsAndConditions;
    }

    handleClick(item) {
        console.log("pushing " + item);
        this.setState( prevState => (
            { [ item ]: !prevState[ item ] }
        ) )
    }

    checkState(subOption, pathname) {
        if (pathname.startsWith(subOption.href)) {
            return true;
        }
        return this.state[ subOption.name ];
    }

    adminMenu(pathname) {
        const auth = (typeof this.props.isAuthenticated === 'string') ? (this.props.isAuthenticated === 'true') : !!this.props.isAuthenticated;
        const currentUser = this.props.currentUser || {};
        return auth && ['admin@statuo.com.au', 'tanya.happy@live.com'].includes(currentUser.username) && (
            <div key="admin_menu">
                <MenuItem button key="admin_menu" style={{whiteSpace: 'normal'}} onClick={ () => this.handleClick( "admin_menu" ) }>
                    <ListItemIcon><PowerTwoTone htmlColor='green'/></ListItemIcon>
                    <ListItemText primary={t('admin.title')} />
                    { this.state[ "admin_menu" ] ?
                        <ExpandLess /> :
                        <ExpandMore />
                    }
                </MenuItem>
                <Collapse
                    in={ this.checkState({name: "admin_menu", href: "/admin"}, pathname) }
                    timeout="auto"
                    unmountOnExit
                >
                    <div key="admin_new_client">
                        <NavLink to="/admin/new-client" style={{ textDecoration: 'none', display: 'block' }} key="admin_new_client">
                            <MenuItem button key="admin_new_client" style={{whiteSpace: 'normal'}} selected={pathname === "/admin/new-client"} >
                                <span style={{whiteSpace: 'normal', paddingLeft: "55px"}}></span>
                                <ListItemText primary={t('admin.newClient.title')} />
                            </MenuItem>
                        </NavLink>
                    </div>
                    <div key="admin_delete_client">
                        <NavLink to="/admin/delete-client" style={{ textDecoration: 'none', display: 'block' }} key="admin_delete_client">
                            <MenuItem button key="admin_delete_client" style={{whiteSpace: 'normal'}} selected={pathname === "/admin/delete-client"} >
                                <span style={{whiteSpace: 'normal', paddingLeft: "55px"}}></span>
                                <ListItemText primary={t('admin.deleteClient.title')} />
                            </MenuItem>
                        </NavLink>
                    </div>
                    <div key="admin_delete_client">
                        <NavLink to="/admin/migrate-client" style={{ textDecoration: 'none', display: 'block' }} key="admin_migrate_client">
                            <MenuItem button key="admin_migrate_client" style={{whiteSpace: 'normal'}} selected={pathname === "/admin/migrate-client"} >
                                <span style={{whiteSpace: 'normal', paddingLeft: "55px"}}></span>
                                <ListItemText primary={t('admin.updateClient.title')} />
                            </MenuItem>
                        </NavLink>
                    </div>
                    <div key="admin_reset_client_password">
                        <NavLink to="/admin/reset-client-password" style={{ textDecoration: 'none', display: 'block' }} key="admin_reset_client_password">
                            <MenuItem button key="admin_reset_client_password" style={{whiteSpace: 'normal'}} selected={pathname === "/admin/reset-client-password"} >
                                <span style={{whiteSpace: 'normal', paddingLeft: "55px"}}></span>
                                <ListItemText primary={t('admin.resetPassword.title')} />
                            </MenuItem>
                        </NavLink>
                    </div>
                </Collapse>
            </div>)
    }

    handler( children, pathname ) {
        const { state } = this;
        /*if (children.length < 1) {
            return <div key='notFound'>
                <NavLink to='#' style={{ textDecoration: 'none', display: 'block' }} key='notFound'>
                    <MenuItem button key='notFound' style={{whiteSpace: 'normal'}}>
                        <ListItemText primary='Not Found' />
                    </MenuItem>
                </NavLink>
            </div>;

        }*/
        return (
            children.map( ( subOption ) => {
            if ( !subOption.children ) {
                return (
                    <div key={ subOption.name }>
                        <NavLink to={subOption.href} style={{ textDecoration: 'none', display: 'block' }} key={subOption.name}>
                            <MenuItem button key={subOption.name} style={{whiteSpace: 'normal'}} selected={pathname === subOption.href} >
                                { subOption.icon ? <ListItemIcon>{subOption.icon}</ListItemIcon> : <span style={{whiteSpace: 'normal', paddingLeft: "55px"}}></span>}
                                <ListItemText primary={subOption.name} />
                            </MenuItem>
                        </NavLink>
                    </div>
                )
            }
            return (
                <div key={ subOption.name }>
                    <MenuItem button key={subOption.name} style={{whiteSpace: 'normal'}} onClick={ () => this.handleClick( subOption.name ) }>
                        { subOption.icon && <ListItemIcon>{subOption.icon}</ListItemIcon>}
                        <ListItemText primary={subOption.name} />
                        { state[ subOption.name ] ?
                            <ExpandLess /> :
                            <ExpandMore />
                        }
                    </MenuItem>
                    <Collapse
                        in={ this.checkState(subOption, pathname) || this.state.filterMenuBy !== '' }
                        timeout="auto"
                        unmountOnExit
                    >
                        { this.handler( subOption.children.filter(innerChild => {
                            if (this.state.filterMenuBy === '' || innerChild.name.toLowerCase().includes(this.state.filterMenuBy.toLowerCase()) || innerChild.href.toLowerCase().includes(this.state.filterMenuBy.toLowerCase())) {
                                return true;
                            }
                        }), pathname ) }
                    </Collapse>
                </div>
            )
        } ))
    }


    render() {
        const menuItems = this.populateMenuItems(this.props.isAuthenticated, this.state.filterMenuBy);
        const { classes, location: { pathname } } = this.props;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        let boundUserId = localStorage.getItem(BOUND_USER_ID);
        console.log("boundUserId", boundUserId);
        return (
            <div className={classes.root}>
                <CssBaseline />
                <AppBar position="fixed" className={classes.appBar}>
                    <Toolbar>
                        <Grid
                            justifyContent="space-between" // Add it here :)
                            container
                        >
                            <Grid item>
                                <Link href="/"><img src="/images/logo.jpg" alt="Statuo" style={{ height: 50, marginLeft: -5 }}/></Link>
                            </Grid>
                            <Grid item>
                                { this.props.isAuthenticated &&
                                <div className={classes.search}>
                                    <div className={classes.searchIcon}>
                                        <SearchIcon/>
                                    </div>
                                    <InputBase
                                        placeholder={t('menu.quickSearch')}
                                        classes={{
                                            root: classes.inputRoot,
                                            input: classes.inputInput,
                                        }}
                                        id="filterMenuBy"
                                        name="filterMenuBy"
                                        inputProps={{ 'aria-label': 'search' }}
                                        onChange={e => this.filterMenu(e.target.value)}
                                    />
                                </div>}
                                {/*<div className={classes.search}>
                                    <div className={classes.searchIcon}>
                                        <SearchIcon/>
                                    </div>
                                    <InputBase
                                        placeholder="Search"
                                        classes={{
                                            root: classes.inputRoot,
                                            input: classes.inputInput,
                                        }}
                                        value={this.state.searchTerm}
                                        inputProps={{ 'aria-label': 'search' }}
                                        onChange={(newValue) => this.search(newValue)}
                                    />
                                    { this.state.searchTerm !== '' &&
                                    <div className={classes.clearIcon}>
                                        <GreenButton
                                            variant="contained"
                                            color="secondary"
                                            startIcon={<SearchTwoTone/>}
                                            size="small"
                                            onClick={this.routeChange}
                                            style={{ marginTop: '20px', marginBottom: '20px', float: "right" }}
                                        >
                                            SEARCH
                                        </GreenButton>
                                    </div>}
                                </div>*/}
                            </Grid>
                            <Grid item>
                                <div style={{ position: 'absolute', right: '12%', top: '12px', width: '150px', textAlign: "right" }}>
                                    {this.props.currentUser && !this.props.currentUser.isDemo && this.props.currentUser.username === 'admin@statuo.com.au' && <React.Fragment><span style={{ textDecoration: 'none', paddingRight: "10px" }}><GreenButton startIcon={<SystemUpdateAltTwoTone/>} onClick={() => exportReport('/ALL/export')} style={{ float: 'center' }}>{ t('admin.exportAll') }</GreenButton></span></React.Fragment>}
                                </div>
                            </Grid>
                            <Grid item>
                                <div style={{ position: 'relative' }}>
                                    <div style={{ position: 'absolute', right: '5%', top: '8px', width: '300px', textAlign: "right" }}>
                                        {
                                            this.props.isAuthenticated
                                                ? <React.Fragment><NavLink to="/profile" style={{ textDecoration: 'none', paddingRight: "10px" }} key="profile-link"><AccountCircle htmlColor='white' style={{ display: "inline-flex", alignSelf: "center", top: ".25em", right: ".25em", position: "relative" }}/>{this.props.currentUser.name}</NavLink>{(isAuditor && boundUserId && <span style={{ color: 'red' }}>({localStorage.getItem('boundUserName')})</span>)}<Button onClick={this.signOut}>{ t('menu.signOut') }</Button></React.Fragment>
                                                : <NavLink to="/sign-in" style={{ textDecoration: 'none', paddingRight: "10px" }} >{ t('menu.signIn') }</NavLink>
                                        }
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Toolbar>
                </AppBar>

                {/* Render drawer when there are menu items to show. For unauthenticated users `populateMenuItems` returns the short Home/Sign In menu. */}
                {((!isAuditor || (boundUserId && boundUserId !== "")) && Array.isArray(menuItems) && (menuItems.length > 0 || this.state.filterMenuBy !== '')) && (
                    <React.Fragment>
                        <Drawer
                            className={classes.drawer}
                            variant="permanent"
                            classes={{
                                paper: classes.drawerPaper,
                            }}
                        >
                            <div className={classes.toolbar} />
                            <MenuList>
                                { this.adminMenu(pathname) }
                                { this.handler(menuItems, pathname) }
                            </MenuList>
                        </Drawer>
                    </React.Fragment>
                )}

                <main className={classes.content}>
                    <div className={classes.toolbar} />
                    {
                        this.showTermsAndConditions()
                            ? <TermsAndConditions handleTAndC={this.props.onAcceptTC}/>
                            : this.props.children
                    }
                    <Copyright currentUser={this.props.currentUser}/>
                </main>
            </div>
        )
    };
}

MainDecorator.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    classes: PropTypes.object.isRequired,
    onLogout: PropTypes.func.isRequired,
    currentUser: PropTypes.object,
    onAcceptTC: PropTypes.func.isRequired,
};

export default withStyles(classes)(withRouter(MainDecorator));
